import React from "react";
import { PuffLoader } from "react-spinners";

const Spinner = ({ loading }) => {
    return (
        loading && (
            <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-white bg-opacity-70 z-50">
                <PuffLoader color="#2563eb" size={80} />
            </div>
        )
    );
};

export default Spinner;
